import * as React from "react"
import { Layout, Seo } from "@/components"
import { HeaderBar } from "@/components/privacy-policy/header-bar"
import t from "@/constants/wording"
import Content from "@/components/privacy-policy/content"

const PrivacyPolicy: React.FC<PrivacyPolicyTemplate> = ({ pageContext }) => {
  return (
    <Layout>
      <Seo
        title={t("Privacy Policy")}
        description={t("Privacy Policy")}
        keywords={t("keywords")}
      />
      <HeaderBar title={`PingCAP ${t("Privacy Policy")}`} />
      <Content {...pageContext.privacyPolicy} />
    </Layout>
  )
}

export default PrivacyPolicy
